import { useState } from 'react';
import { Tooltip as ReactstrapTooltip } from 'reactstrap';

function Tooltip({ text, targetId }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    return (
        <>
            <span 
                id={targetId} 
                className="d-inline-block" 
                onMouseEnter={() => setTooltipOpen(true)} 
                onMouseLeave={() => setTooltipOpen(false)}
                onClick={toggle}
            >
                <i className="fas fa-info-circle text-info" style={{ cursor: 'pointer', marginLeft: '5px' }}></i>
            </span>
            <ReactstrapTooltip
                placement="top"
                isOpen={tooltipOpen}
                target={targetId}
                toggle={toggle}
            >
                {text}
            </ReactstrapTooltip>
        </>
    );
}

export default Tooltip;
